import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function SignalerProblemePage() {
    const [formData, setFormData] = useState({
        nom: "",
        email: "",
        type: "",
        message: "",
    });

    const [success, setSuccess] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSuccess(true);
        setFormData({ nom: "", email: "", type: "", message: "" });
    };

    return (
        <>
            <Helmet>
                <title>Signaler un problème — Thrundrz</title>
                <meta name="description" content="Vous rencontrez un problème sur Thrundrz ? Signalez-le via le formulaire." />
                <link rel="canonical" href="https://thrundrz.fr/signaler-probleme" />
            </Helmet>
            <Navbar />
            <main className="min-h-screen bg-color4 py-16 px-4 lg:pt-28">
                <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-8">
                    <h1 className="text-3xl font-bold text-color1 mb-6 text-center font-Poppins">
                        Signaler un problème
                    </h1>
                    <p className="text-gray-600 text-center mb-8">
                        Rencontrez-vous un bug ou une difficulté ? Remplissez le formulaire ci-dessous 👇
                    </p>

                    {success && (
                        <div className="mb-6 rounded-lg bg-green-100 p-4 text-green-800 text-sm">
                            ✅ Votre signalement a été envoyé avec succès.
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label htmlFor="nom" className="block text-gray-700 font-medium mb-1">
                                Nom complet
                            </label>
                            <input
                                type="text"
                                id="nom"
                                name="nom"
                                value={formData.nom}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-color1"
                                placeholder="John Doe"
                            />
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-gray-700 font-medium mb-1">
                                Adresse e-mail
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-color1"
                                placeholder="exemple@email.com"
                            />
                        </div>

                        <div>
                            <label htmlFor="type" className="block text-gray-700 font-medium mb-1">
                                Type de problème
                            </label>
                            <select
                                id="type"
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-color1"
                            >
                                <option value="">Sélectionner</option>
                                <option value="bug">Bug technique</option>
                                <option value="paiement">Problème de paiement</option>
                                <option value="compte">Compte / connexion</option>
                                <option value="autre">Autre</option>
                            </select>
                        </div>

                        <div>
                            <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
                                Description du problème
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-color1"
                                placeholder="Expliquez votre problème..."
                            ></textarea>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="bg-color1 text-white font-semibold px-6 py-2 rounded-lg hover:bg-color3 transition duration-200"
                            >
                                Envoyer le signalement
                            </button>
                        </div>
                    </form>
                </div>
            </main>
            <Footer />
        </>
    );
}
